import Utils from 'src/utils';
import store from 'src/store';
import { selectUserViewLevel } from 'src/store/selectors/userRight';
import { selectModuleConfiguration } from 'src/store/selectors/configurations';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const REQUEST = 'LOAD_WORK_SHIFTS_REQUEST';
export const SUCCESS = 'LOAD_WORK_SHIFTS_SUCCESS';
export const FAIL = 'LOAD_WORK_SHIFTS_FAIL';

export const SUBMIT_REQUEST = 'SUBMIT_WORK_SHIFT_REQUEST';
export const SUBMIT_SUCCESS = 'SUBMIT_WORK_SHIFT_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_WORK_SHIFT_FAIL';

export const UPDATE_REQUEST = 'UPDATE_WORK_SHIFT_REQUEST';
export const UPDATE_SUCCESS = 'UPDATE_WORK_SHIFT_SUCCESS';
export const UPDATE_FAIL = 'UPDATE_WORK_SHIFT_FAIL';

export const DELETE_REQUEST = 'DELETE_WORK_SHIFT_REQUEST';
export const DELETE_SUCCESS = 'DELETE_WORK_SHIFT_SUCCESS';
export const DELETE_FAIL = 'DELETE_WORK_SHIFT_FAIL';

const loadWorkShiftsRequest = () => ({ type: REQUEST });
const loadWorkShiftsSuccess = (workShifts) => ({ type: SUCCESS, workShifts });
const loadWorkShiftsFail = (error) => ({ type: FAIL, error });

const submitWorkShiftRequest = () => ({ type: SUBMIT_REQUEST });
const submitWorkShiftSuccess = (workShift) => ({ type: SUBMIT_SUCCESS, workShift });
const submitWorkShiftFail = (error) => ({ type: SUBMIT_FAIL, error });

const updateWorkShiftRequest = () => ({ type: UPDATE_REQUEST });
const updateWorkShiftSuccess = (workShift) => ({ type: UPDATE_SUCCESS, workShift });
const updateWorkShiftFail = (error) => ({ type: UPDATE_FAIL, error });

const deleteWorkShiftRequest = () => ({ type: DELETE_REQUEST });
const deleteWorkShiftSuccess = (workShift) => ({ type: DELETE_SUCCESS, workShift });
const deleteWorkShiftFail = (error) => ({ type: DELETE_FAIL, error });

export const loadWorkShifts = () => (dispatch) => {
  const storeState = store.getState();
  const userViewLevel = selectUserViewLevel(storeState);
  const plannerModuleConfig = selectModuleConfiguration(storeState, 'Planner');
  dispatch(loadWorkShiftsRequest());
  const url = plannerModuleConfig.WorkshiftsByRights && userViewLevel === 'Department' ? 'WorkShifts/GetByDepartments' : 'WorkShifts';
  return communicate({ url })
    .then((response) => {
      dispatch(loadWorkShiftsSuccess(response.data.Data));
      return response.data.Data;
    }).catch((err) => {
      dispatch(loadWorkShiftsFail(err));
      toastrError(err);
    });
};

export const submitWorkShift = (workShift) => (dispatch) => {
  dispatch(submitWorkShiftRequest());
  return communicate({ url: 'WorkShifts', method: 'post', data: workShift }).then((response) => {
    toastrSuccess(response);
    dispatch(submitWorkShiftSuccess(response.data.Data));
    return response.data.Data;
  }).catch((err) => {
    dispatch(submitWorkShiftFail(err));
    toastrError(err);
  });
};

export const updateWorkShift = (workShift) => (dispatch) => {
  dispatch(updateWorkShiftRequest());
  return communicate({ url: 'WorkShifts', method: 'put', data: workShift }).then((response) => {
    toastrSuccess(response);
    dispatch(updateWorkShiftSuccess(response.data.Data));
    return response.data.Data;
  }).catch((err) => {
    dispatch(updateWorkShiftFail(err));
    toastrError(err);
  });
};

export const deleteWorkShift = (workShift) => (dispatch) => {
  dispatch(deleteWorkShiftRequest());
  return communicate({ url: 'WorkShifts', method: 'delete', getParams: `?Id=${workShift.Id}` }).then((response) => {
    toastrSuccess(response);
    dispatch(deleteWorkShiftSuccess(workShift.Id));
  }).catch((err) => {
    dispatch(deleteWorkShiftFail(err));
    toastrError(err);
  });
};

export const getWorkShiftsByDepartmentsAssociations = (departmentIds) => () => {
  const getParams = Utils.objects.getQueryStringFromObject({ departmentIds, isDeleted: false });
  return communicate({ url: 'WorkShiftDepartments', method: 'get', getParams })
    .then((response) => Promise.resolve(response.data.Data))
    .catch((err) => toastrError(err) && Promise.reject());
};

export const submitWorkShiftAndDepartmentsAssociations = ({ workShiftIds, departmentIds }) => () => {
  const data = { workShiftIds, departmentIds };
  return communicate({ url: 'WorkShiftDepartments/multiple', method: 'post', data })
    .then((response) => {
      toastrSuccess(response);
      return Promise.resolve(response.data.Data);
    })
    .catch((err) => toastrError(err) && Promise.reject());
};

export const deleteWorkShiftAndDepartmentAssociation = ({ workShiftIds, departmentIds }) => () => {
  const getParams = Utils.objects.getQueryStringFromObject({ workShiftIds, departmentIds });
  return communicate({ url: 'WorkShiftDepartments/multiple', method: 'delete', getParams })
    .then((response) => {
      toastrSuccess(response);
      return Promise.resolve();
    })
    .catch((err) => toastrError(err) && Promise.reject());
};
